/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { IconButton } from "@mui/material";
import TableComponent from "../../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import { removeFromStorage, STORAGE_KEYS } from "../../../helpers";
import { formatDubaiDateTime } from "../../../utils/dateTime";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { OFFER_SORTING } from "../../../utils/enums";

type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired" | "archived";
  offerType?: "dining" | "event" | "expired" | "experience" | "others";
  offerData?: any[];
  valueTabs1: number;
  valueTabs: number;
  categoryId: string | null;
  categoryName: string;
  changeOfferStatusApi: (id: string) => void;
  sortOrder: string;
  setCurrentSortOrder: (order: string) => void;
};

const OfferTable = ({
  actionType = "active",
  offerType = "dining",
  offerData = [],
  valueTabs1,
  valueTabs,
  categoryId,
  categoryName = "",
  changeOfferStatusApi,
  sortOrder,
  setCurrentSortOrder,
}: OfferTableProps) => {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "OfferName",
      renderHeader: () => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            fontWeight: "700",
            fontSize: "16px",
          }}
        >
          Offer Name
          <SwapVertIcon
            onClick={() =>
              setCurrentSortOrder(
                sortOrder === OFFER_SORTING.Title_asc
                  ? "Title_desc"
                  : "Title_asc"
              )
            }
          />
        </div>
      ),
      flex: 1,
      minWidth: 140,
      renderCell: ({ row }) => (
        <div
          role="button"
          tabIndex={0}
          style={{ cursor: "pointer", color: "#1976d2" }}
          onClick={() =>
            navigate(`/manage-offer/preview-offer-detail/${row?.id}`, {
              state: {
                status: valueTabs1,
                actionType: actionType,
                categoryTab: valueTabs,
                categoryId: categoryId,
                categoryName: categoryName,
                type:
                  row?.offerType === "event"
                    ? "EVENT"
                    : row?.offerType === "experience"
                      ? "EXPERIENCE"
                      : "RESTAURANT", // fallback
              },
            })
          }
        >
          <p>{row?.title || "-"}</p>
        </div>
      ),
    },

    // Conditionally include StartDate column
    ...(offerType === "experience"
      ? []
      : [
          {
            field: "StartDate",

            renderHeader: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                {offerType === "event" ? "Event Date" : "Start Date"}
                <SwapVertIcon
                  onClick={() =>
                    setCurrentSortOrder(
                      sortOrder === OFFER_SORTING.StartDate_asc
                        ? "StartDate_desc"
                        : "StartDate_asc"
                    )
                  }
                />
              </div>
            ),
            flex: 1,
            minWidth: 95,
            renderCell: ({ row }: any) => (
              <div>
                <p>
                  {row?.offerStartDate
                    ? formatDubaiDateTime(row?.offerStartDate)
                    : "-"}
                </p>
              </div>
            ),
          },
        ]),

    {
      field: offerType === "event" ? "eventTime" : "EndDate",
      renderHeader: () => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            fontWeight: "700",
            fontSize: "16px",
          }}
        >
          {offerType === "event" ? "Event Time" : "End Date"}
          <SwapVertIcon
            onClick={() =>
              setCurrentSortOrder(
                sortOrder === OFFER_SORTING.EndDate_asc
                  ? "EndDate_desc"
                  : "EndDate_asc"
              )
            }
          />
        </div>
      ),
      flex: 1,
      minWidth: 95,
      renderCell: ({ row }: any) => (
        <div>
          <p>
            {row?.offerEndDate ? formatDubaiDateTime(row?.offerEndDate) : "-"}
          </p>
        </div>
      ),
    },
    {
      field: "ButterflyEffect",
      headerName: "Butterfly Effect",
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }: any) => (
        <div>
          <p>{row?.isButterflyEffect ? "Yes" : "No"}</p>
        </div>
      ),
    },
    {
      field: "CancellationPolicy",
      headerName: "Cancellation Policy",
      flex: 1,
      minWidth: 100,
      renderCell: ({ row }: any) => (
        <div>
          <p>{row?.isCancellationPolicy ? "Yes" : "No"}</p>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 130,
      renderCell: ({ row }) => {
        if (actionType === "active") {
          return (
            <div className="table_actions v2">
              <IconButton className="toggle_btn">
                <IosSwitchMain
                  checked={row?.isActive}
                  onChange={() => changeOfferStatusApi(row?.id)}
                />
              </IconButton>
              <IconButton
                className="edit_icon"
                onClick={() => {
                  removeFromStorage(STORAGE_KEYS.offerData);
                  removeFromStorage(STORAGE_KEYS.offerImages);
                  navigate(`/manage-offer/build-offer/edit/${row?.id}`, {
                    state: {
                      status: valueTabs1,
                      actionType: actionType,
                      categoryTab: valueTabs,
                      categoryId: categoryId,
                      categoryName: categoryName,
                    },
                  });
                }}
              >
                <img src="/static/images/edit_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "scheduled") {
          return (
            <div className="table_actions v2">
              <IconButton className="edit_icon">
                <img src="/static/images/calendar_icon.svg" alt="icon" />
              </IconButton>
              <IconButton
                className="edit_icon"
                onClick={() => {
                  removeFromStorage(STORAGE_KEYS.offerData);
                  removeFromStorage(STORAGE_KEYS.offerImages);
                  navigate(`/manage-offer/build-offer/edit/${row?.id}`, {
                    state: {
                      status: valueTabs1,
                      actionType: actionType,
                      categoryTab: valueTabs,
                      categoryId: categoryId,
                      categoryName: categoryName,
                    },
                  });
                }}
              >
                <img src="/static/images/edit_icon.svg" alt="icon" />
              </IconButton>
            </div>
          );
        } else if (actionType === "expired" || actionType === "archived") {
          return (
            <div className="table_actions v2">
              {actionType === "archived" ? (
                <IconButton
                  className="edit_icon"
                  onClick={() => {
                    removeFromStorage(STORAGE_KEYS.offerData);
                    removeFromStorage(STORAGE_KEYS.offerImages);
                    navigate(`/manage-offer/build-offer/edit/${row?.id}`, {
                      state: {
                        status: valueTabs1,
                        actionType: actionType,
                        categoryTab: valueTabs,
                        categoryId: categoryId,
                        categoryName: categoryName,
                      },
                    });
                  }}
                >
                  <img src="/static/images/edit_icon.svg" alt="icon" />
                </IconButton>
              ) : null}

              <IconButton className="edit_icon">
                <img
                  src="/static/images/copy_icon.svg"
                  alt="icon"
                  onClick={() => {
                    removeFromStorage(STORAGE_KEYS.offerData);
                    removeFromStorage(STORAGE_KEYS.offerImages);
                    navigate(`/manage-offer/build-offer/edit/${row?.id}`, {
                      state: {
                        isClone: true,
                        status: valueTabs1,
                        actionType: actionType,
                        categoryTab: valueTabs,
                        categoryId: categoryId,
                        categoryName: categoryName,
                      },
                    });
                  }}
                />
              </IconButton>
            </div>
          );
        }
        return null;
      },
    },
  ];

  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table cards table_cards">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={offerData}
        />
      </div>
    </>
  );
};

export default OfferTable;
